/* Forged Racing — predictive search modal.
   Live results from /search/suggest.json, 300ms debounce, keyboard nav. */
(function () {
  'use strict';

  var root = null;
  var input = null;
  var refs = {};
  var debounceTimer = null;
  var activeQuery = '';
  var highlighted = -1;

  function money(value) {
    // suggest.json returns prices as decimal strings ("59.99")
    var symbol = (document.body.dataset.currency === 'USD' || !document.body.dataset.currency) ? '$' : document.body.dataset.currency + ' ';
    var n = typeof value === 'string' ? parseFloat(value) : value / 100;
    if (isNaN(n)) return '';
    return symbol + n.toFixed(2);
  }

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  // suggest.json returns full-size CDN urls; request a sized rendition
  function sized(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function show(el, on) {
    if (el) el.hidden = !on;
  }

  function setState(state) {
    show(refs.initial, state === 'initial');
    show(refs.loading, state === 'loading');
    show(refs.empty, state === 'empty');
    if (state !== 'results') {
      show(refs.products, false);
      show(refs.collections, false);
      show(refs.viewAll, false);
      /* ROUND 56: the approximate-results note must never outlive the results
         it describes — clearing the box or a new search must not leave it
         labelling an exact result set as approximate. */
      show(refs.fuzzyNote, false);
    }
  }

  /* ROUND 55: the suggested-product thumbs ship without a src so they cost
     nothing on page load — loading="lazy" does NOT defer an image inside a
     [hidden] container, it just fetches it. Promote them the first time the
     modal opens; after that the browser cache handles it. */
  function loadSuggestionImages() {
    if (!root) return;
    var pending = root.querySelectorAll('img[data-forged-lazy-src]');
    for (var i = 0; i < pending.length; i++) {
      var img = pending[i];
      img.src = img.getAttribute('data-forged-lazy-src');
      img.removeAttribute('data-forged-lazy-src');
    }
  }

  function open() {
    if (!root) return;
    loadSuggestionImages();
    /* ROUND 55: reopening used to restore whatever was on screen when the modal
       was last closed, so after one search the suggested products never came
       back. Reset to the initial state — which is where the suggestions live —
       whenever the box is empty. A query the customer actually left in the box
       is preserved along with its results. */
    if (input && !input.value.trim()) {
      activeQuery = '';
      highlighted = -1;
      setState('initial');
    }
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('forged-scroll-lock');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      input.focus();
    });
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('forged-scroll-lock');
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 240);
  }

  function items() {
    return Array.prototype.slice.call(
      root.querySelectorAll('.forged-search__product:not([hidden]), .forged-search__collection:not([hidden])')
    );
  }

  function highlight(index) {
    var list = items();
    if (!list.length) return;
    highlighted = (index + list.length) % list.length;
    list.forEach(function (el, i) {
      el.classList.toggle('is-highlighted', i === highlighted);
    });
    list[highlighted].scrollIntoView({ block: 'nearest' });
  }

  function renderProducts(products) {
    refs.productGrid.innerHTML = products
      .map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var compare = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price);
        return (
          '<a href="' + esc(p.url) + '" class="forged-search__product">' +
          '<span class="forged-search__product-media">' +
          /* ROUND 55: was 400. .forged-search__product-media renders this in a
             52px box, so 400w was ~7.7x oversized on every result row. 160w
             still covers a 3x screen. */
          (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" width="52" height="52" loading="lazy">' : '') +
          '</span>' +
          '<span class="forged-search__product-title">' + esc(p.title) + '</span>' +
          '<span class="forged-search__product-price' + (compare ? ' is-sale' : '') + '">' +
          money(p.price) +
          (compare ? ' <s>' + money(p.compare_at_price_max) + '</s>' : '') +
          '</span>' +
          '</a>'
        );
      })
      .join('');
  }

  function renderCollections(collections) {
    refs.collectionGrid.innerHTML = collections
      .map(function (c) {
        var img = c.featured_image && c.featured_image.url ? c.featured_image.url : '';
        return (
          '<a href="' + esc(c.url) + '" class="forged-search__collection">' +
          (img
            ? '<img src="' + esc(sized(img, 120)) + '" alt="" loading="lazy">'
            : '<span class="forged-search__collection-placeholder" aria-hidden="true"></span>') +
          '<span class="forged-search__collection-title">' + esc(c.title) + '</span>' +
          '</a>'
        );
      })
      .join('');
  }

  /* =====================================================================
     ROUND 56 — TYPO TOLERANCE (Dario: "account for typos in the search bar,
     just find most similar to what words they type").

     WHAT SHOPIFY ALREADY DOES. Measured against this catalogue before writing
     any of this, because the feature is only worth what it adds:
       surron, sur-ron, sur ron, talara, talarria, wheelsett, ultrabee,
       segwey, kickstnad, sprokcet, rotorr, chargr, suspention, controler
       -> ALL already return results. Shopify is far more forgiving than
          expected, so this only runs when it genuinely returns nothing.

     WHAT ACTUALLY FAILS, and what recovers it:
       "moter cover", "brihgt light", "sur-ron ultrabe"  -> retry each token
       "handelbar", "batery"                             -> shorter prefixes
       "grpis" (grips)                                   -> transposition
       "britelight", "fottpegs"                          -> still nothing, and
                                                            they correctly fall
                                                            through to the empty
                                                            state

     COST. Nothing is shipped on page load — no catalogue, no title index, no
     dictionary. The 391 products stay on the server. This is pure logic inside
     a file that already loads, and it only touches the network after a search
     has already come back empty, which is the one moment a few extra requests
     are clearly worth it.

     HONESTY. Matches found this way are approximate and are labelled as such;
     they are never presented as exact hits. If nothing clears the similarity
     threshold the customer gets the ordinary empty state rather than the
     nearest random product.
     ===================================================================== */

  var MAX_VARIANTS = 8;
  var MIN_SIMILARITY = 0.55;

  function levenshtein(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = new Array(n + 1), cur = new Array(n + 1), i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      var swap = prev; prev = cur; cur = swap;
    }
    return prev[n];
  }

  function tokens(s) {
    return String(s || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  /* Best similarity between one typed word and any word in a title. A prefix
     relationship scores on length overlap ("hand" vs "handlebar"), everything
     else on edit distance. */
  function bestTokenScore(qt, titleTokens) {
    var best = 0;
    for (var i = 0; i < titleTokens.length; i++) {
      var t = titleTokens[i], s;
      if (t.indexOf(qt) === 0 || qt.indexOf(t) === 0) {
        s = Math.min(qt.length, t.length) / Math.max(qt.length, t.length);
      } else {
        s = 1 - levenshtein(qt, t) / Math.max(qt.length, t.length);
      }
      if (s > best) best = s;
    }
    return best;
  }

  function scoreTitle(query, title) {
    var qs = tokens(query);
    if (!qs.length) return 0;
    var tt = tokens(title), total = 0;
    for (var i = 0; i < qs.length; i++) total += bestTokenScore(qs[i], tt);
    return total / qs.length;
  }

  /* Generic transforms only — no misspelling dictionary, so this keeps working
     as the catalogue grows. Ordered cheapest-and-most-likely first because the
     list is capped. */
  function relaxedVariants(query) {
    var out = [], seen = {};
    function add(v) {
      v = String(v || '').trim();
      if (v.length >= 3 && v !== query && !seen[v]) { seen[v] = 1; out.push(v); }
    }
    var toks = tokens(query);
    add(query.replace(/[\s\-_]+/g, ''));  /* sur-ron -> surron */
    add(query.replace(/[\-_]+/g, ' '));   /* sur-ron -> sur ron */
    if (toks.length > 1) toks.forEach(add);            /* drop the bad word */
    var longest = toks.slice().sort(function (a, b) { return b.length - a.length; })[0] || '';
    for (var k = 1; k <= 3; k++) {                     /* trailing typos, plurals */
      if (longest.length - k >= 3) add(longest.slice(0, longest.length - k));
    }
    for (var i = 0; i < longest.length - 1; i++) {     /* adjacent transposition */
      add(longest.slice(0, i) + longest.charAt(i + 1) + longest.charAt(i) + longest.slice(i + 2));
    }
    return out.slice(0, MAX_VARIANTS);
  }

  function suggestUrl(q, limit) {
    return '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=hide';
  }

  function fuzzyFallback(query) {
    var variants = relaxedVariants(query);
    if (!variants.length) { setState('empty'); return; }
    Promise.all(variants.map(function (v) {
      return fetch(suggestUrl(v, 5))
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    })).then(function (all) {
      if (query !== activeQuery) return; /* customer typed on — drop this */
      var byHandle = {};
      all.forEach(function (d) {
        var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        ps.forEach(function (p) {
          if (p.handle === 'shipping-protection') return;
          if (!byHandle[p.handle]) byHandle[p.handle] = p;
        });
      });
      var scored = Object.keys(byHandle).map(function (h) {
        return { p: byHandle[h], score: scoreTitle(query, byHandle[h].title) };
      }).filter(function (x) { return x.score >= MIN_SIMILARITY; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 6);

      if (!scored.length) { setState('empty'); return; }
      setState('results');
      renderProducts(scored.map(function (x) { return x.p; }));
      show(refs.products, true);
      show(refs.collections, false);
      if (refs.fuzzyNote) {
        refs.fuzzyNote.textContent =
          'No exact matches for "' + query + '". Showing similar products.';
        show(refs.fuzzyNote, true);
      }
      refs.viewAll.href = '/search?q=' + encodeURIComponent(query);
      show(refs.viewAll, true);
    });
  }

  function search(query) {
    activeQuery = query;
    setState('loading');
    if (refs.fuzzyNote) show(refs.fuzzyNote, false);
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product,collection&resources[limit]=6' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,vendor,product_type,variants.title,tag';
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (query !== activeQuery) return; // stale response
        var results = (data.resources && data.resources.results) || {};
        var products = (results.products || []).filter(function (p) {
          /* Shipping Protection is a cart add-on, not a searchable product. */
          return p.handle !== 'shipping-protection';
        });
        var collections = results.collections || [];
        highlighted = -1;
        show(refs.loading, false);
        if (!products.length && !collections.length) {
          /* ROUND 56: Shopify found nothing. Before showing the dead end, try
             generically relaxed spellings of what they typed. Only here — the
             exact path above is untouched. */
          fuzzyFallback(query);
          return;
        }
        setState('results');
        show(refs.products, products.length > 0);
        show(refs.collections, collections.length > 0);
        if (products.length) renderProducts(products);
        if (collections.length) renderCollections(collections);
        refs.viewAll.href = '/search?q=' + encodeURIComponent(query);
        show(refs.viewAll, true);
      })
      .catch(function () {
        if (query === activeQuery) setState('empty');
      });
  }

  function onInput() {
    clearTimeout(debounceTimer);
    var value = input.value.trim();
    if (!value) {
      activeQuery = '';
      setState('initial');
      return;
    }
    debounceTimer = setTimeout(function () {
      search(value);
    }, 300);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      if (input.value) {
        input.value = '';
        activeQuery = '';
        setState('initial');
        input.focus();
      } else {
        close();
      }
      return;
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      highlight(highlighted + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      highlight(highlighted - 1);
    } else if (event.key === 'Enter') {
      /* ROUND 81 — Enter has TWO correct outcomes and the code only ever
         implemented one of them.

         1. A suggestion is highlighted with the arrow keys. That is an explicit
            pick, so it wins over the query text; go straight there. This is the
            branch that already existed.

         2. Nothing is highlighted — the ordinary case, and the one that was
            dead. Do NOT handle it here: let the event through so the browser
            performs its own implicit submission of the form the input now sits
            in (see forged-search-modal.liquid). That native path is also what
            the mobile keyboard's Go/Search key and the submit button trigger,
            so all three routes stay identical by construction rather than by
            three handlers that have to be kept in step.

         The empty-query guard deliberately is NOT here either — it lives on the
         form's submit event below, so it covers every route into a search, not
         just this key. */
      if (highlighted > -1) {
        var list = items();
        if (list[highlighted]) {
          event.preventDefault();
          window.location.assign(list[highlighted].href);
        }
      }
    } else if (event.key === 'Tab') {
      // containment: keep focus between submit/input and close button + results
      var focusables = [refs.submit, input]
        .filter(Boolean)
        .concat(items())
        .concat([root.querySelector('.forged-search__close')]);
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function init() {
    root = document.querySelector('[data-forged-search]');
    if (!root) return;
    input = root.querySelector('[data-forged-search-input]');
    refs = {
      initial: root.querySelector('[data-forged-search-initial]'),
      loading: root.querySelector('[data-forged-search-loading]'),
      empty: root.querySelector('[data-forged-search-empty]'),
      products: root.querySelector('[data-forged-search-products]'),
      collections: root.querySelector('[data-forged-search-collections]'),
      productGrid: root.querySelector('[data-forged-search-product-grid]'),
      fuzzyNote: root.querySelector('[data-forged-search-fuzzy-note]'),
      collectionGrid: root.querySelector('[data-forged-search-collection-grid]'),
      viewAll: root.querySelector('[data-forged-search-view-all]'),
      form: root.querySelector('[data-forged-search-form]'),
      submit: root.querySelector('.forged-search__submit')
    };

    window.ForgedSearch = { open: open, close: close };

    input.addEventListener('input', onInput);
    root.addEventListener('keydown', onKeydown);

    /* ROUND 81 — one guard for every way a search can be submitted: the Enter
       key, the mobile keyboard's Go/Search key, and the magnifier button. An
       empty or whitespace-only box must do nothing rather than load
       /search?q= , which renders a bare "Search" page that looks broken.
       Trimming here also keeps a stray leading space out of the query string
       and out of the "results for ..." heading on the results page. */
    if (refs.form) {
      refs.form.addEventListener('submit', function (event) {
        var q = input.value.trim();
        if (!q) {
          event.preventDefault();
          input.focus();
          return;
        }
        input.value = q;
      });
    }
    root.querySelectorAll('[data-forged-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-forged-search-trigger]');
      if (trigger) {
        event.preventDefault();
        open();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
